export const jpVisaType = [
  { label: '单次旅行', value: '单次旅行' },
  { label: '多次往返旅行', value: '多次往返旅行' },
  { label: '留学', value: '留学' },
  { label: '研修（技能实习）', value: '研修（技能实习）' },
  { label: '特定活动', value: '特定活动' },
  { label: '就职', value: '就职' },
  { label: '其他', value: '其他' },
];

export const koVisaType = [
  { label: '单次旅行', value: '单次旅行' },
  { label: '多次往返旅行', value: '多次往返旅行' },
  { label: '留学', value: '留学' },
  { label: '研修（技能实习）', value: '研修（技能实习）' },
  { label: '其他', value: '其他' },
];

export const examStatus = [
  { value: 0, label: '计划报名' },
  { value: 1, label: '已报名' },
  { value: 2, label: '已合格' },
  { value: 3, label: '未合格' },
];

export const topik = [
  { value: 1, label: 'TOPIK1' },
  { value: 2, label: 'TOPIK2' },
  { value: 3, label: 'TOPIK3' },
  { value: 4, label: 'TOPIK4' },
  { value: 5, label: 'TOPIK5' },
  { value: 6, label: 'TOPIK6' },
];

export const enExamType = [
  { value: 'ielts', label: 'IELTS' },
  { value: 'toefl', label: 'TOEFL' },
];

export const jpExamType = [
  { value: 'jlpt', label: 'JLPT' },
  { value: 'jtest', label: 'Jtest' },
  { value: 'nat', label: 'NATtest' },
  { value: 'other', label: '其他' },
];

export const relations = [
  { value: '父亲', label: '父亲' },
  { value: '母亲', label: '母亲' },
  { value: '其他', label: '其他' },
];


export const eduType = [
  { value: '小学', label: '小学' },
  { value: '初中', label: '初中' },
  { value: '高中/中专', label: '高中/中专' },
  { value: '大专', label: '大专' },
  { value: '本科', label: '本科' },
  { value: '硕士', label: '硕士' },
];

export const eduTypeKorea = [
  { value: '高中/中专', label: '高中/中专' },
  { value: '大专', label: '大专' },
  { value: '本科', label: '本科' },
  { value: '硕士', label: '硕士' },
];

export const jpOtherEduType = [
  { value: '其他', label: '其他' },
];

export const koEduTypeOther = [
  { value: '其他', label: '其他：转学/交换/留学' },
];

export const examTypeKr = [
  { value: 'topik', label: 'TOPIK' },
  { value: 'other', label: '其他' },
];

export const examTypeJp = [
  { value: 'jlpt', label: 'JLPT' },
  { value: 'jtest', label: 'Jtest' },
  { value: 'nat', label: 'NATtest' },
  { value: 'other', label: '其他' },
];

export const jobStatus = [
  { value: 1, label: '在职' },
  { value: 0, label: '离职' },
];
